import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCheckmark1Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"checkmark-1-medium"} maskId="square-filled-radius-0-stroke-1-IconCheckmark1Medium"><path d="M19.0479 6.83301L10.1357 19.1357L4.93945 14.1748L5.97559 13.0898L9.92773 16.8643L17.3926 6.55957L17.833 5.95312L19.0479 6.83301Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCheckmark1Medium;
